.bp{flex-shrink:0;}